import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

export const EducationDashboardPage: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Дашборд Образовательного Учреждения
        </Typography>
        <Typography variant="body1">
          Добро пожаловать! Здесь будет отображаться информация, специфичная для образовательных учреждений.
        </Typography>
        {/* Здесь будет контент для образовательного учреждения */}
      </Paper>
    </Box>
  );
};
